import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Box = styled.div<any>`
  display: flex;
  align-items: center;
  margin-top: 20px;
  width: 50%;
`;

export const WrapperButton = styled.div`
  display: flex;
  margin: 50px 0 60px 0;
  width: 50%;
  justify-content: flex-end;
`;
